/* 司馬懿傳・第 3 章：遼東（238 年）
 * 西邊是遼水（南北向，沒有橋），魏軍從西岸來。東岸是卑衍、楊祚的遼隧大營（圍塹二十餘里）。
 * 北邊上游有一處可以泛舟潛濟的河灣。往東是首山與襄平城；梁水在襄平南邊東西流過，星墜之所在梁水北岸。 */
export const CITY = { x: 7500, y: 2300, hw: 560, hh: 420 };
const T = 36, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const START = [1000, 2600], SUI = [3500, 2700], DOCK = [1900, 900], LAND = [2850, 900], CAMP = [6000, 1500];
export const FLAGS = [[1500, 3700], [1900, 4200], [1100, 4300]], SGATE = [CITY.x + 150, S], WGATE = [Wx, CITY.y], STAR = [8400, 3820];
export const MOUNDS = [[CITY.x - 900, CITY.y - 600], [CITY.x - 900, CITY.y + 600], [CITY.x + 900, CITY.y - 600], [CITY.x + 900, CITY.y + 600]], GRAZE = [[6600, 3200], [8600, 1500], [8700, 3000]];
export default {
  id: 'simayi_liaodong', name: '遼東襄平', W: 10000, H: 5000, seed: 2382,
  bases: [START, [CITY.x, CITY.y]],
  walls: [[CITY.x, N, CITY.hw + T, T], [E, CITY.y, T, CITY.hh], [Wx, (N + CITY.y - 130) / 2, T, (CITY.y - 130 - N) / 2], [Wx, (S + CITY.y + 130) / 2, T, (S - CITY.y - 130) / 2],
    [(Wx + SGATE[0] - 130) / 2, S, (SGATE[0] - 130 - Wx) / 2, T], [(E + SGATE[0] + 130) / 2, S, (E - SGATE[0] - 130) / 2, T]],
  rivers: [
    { pts: [[2300, -100], [2350, 1400], [2250, 2800], [2400, 5100]], hw: 210, fords: [] }, // 遼水
    { pts: [[5000, 4100], [6800, 3950], [8400, 3950], [10100, 4050]], hw: 140, fords: [] }, // 梁水
  ],
  roads: [
    { pts: [LAND, [4200, 1100], CAMP, [CITY.x - 900, CITY.y], WGATE, [CITY.x, CITY.y]], w: 140 },
    { pts: [[2700, 2700], SUI, [4800, 2300], [CITY.x - 900, CITY.y]], w: 120 },
    { pts: [[CITY.x, CITY.y], SGATE, [SGATE[0], 3500], [STAR[0], STAR[1] - 150], [9800, 3600]], w: 110 },
    { pts: [START, [1700, 1600], DOCK], w: 110 },
    { pts: [START, FLAGS[0], FLAGS[1]], w: 100 },
  ],
  rocks: [[5400, 3300, 520, 260], [4600, 400, 400, 160], [9300, 800, 400, 200], [600, 1200, 300, 180]], // 首山
  woods: 0.3,
  sight: 1,
  clearings: [[START[0], START[1], 600], [SUI[0], SUI[1], 700], [CAMP[0], CAMP[1], 500], [CITY.x, CITY.y, 1200], [STAR[0], STAR[1] - 200, 350], [DOCK[0], DOCK[1], 300], [LAND[0], LAND[1], 300], [FLAGS[1][0], FLAGS[1][1], 500]],
  tents: [{ x: SUI[0], y: SUI[1], n: 9, r: 520, chief: true, col: '#5a4a6a', flag: '燕' }, { x: CAMP[0], y: CAMP[1], n: 6, r: 380, chief: true, col: '#3b5a99', flag: '司馬' }],
  villages: [{ x: CITY.x, y: CITY.y, n: 8, r: 380 }],
  fields: [[GRAZE[0][0], GRAZE[0][1], 520, 240, '#7e8a4a'], [GRAZE[1][0], GRAZE[1][1], 520, 240, '#7e8a4a'], [GRAZE[2][0], GRAZE[2][1], 480, 240, '#7e8a4a']],
  palette: { grass: [70, 86, 58] },
};
